import { type DownloadFile } from "../models/types";
import { sortResults } from "./downloads-utility";
import filters, { type FilterOption } from "../data/download-filters";


export const getFilters = (fieldName: string, keys: string[]) => {
    const options = filters[fieldName].options;
    const selected = options.filter((f : FilterOption) => {
        return keys.includes(f.key);
    });
    return selected;
}

export const getMatches = (downloads: DownloadFile[], filters: Record<string, FilterOption[]>) => {
    if (!downloads){
        return null;
    }
    const matches = downloads.filter((d : DownloadFile) => {
        return isMatch(d, filters);
    });
    matches.sort(sortResults);
    
    return matches;
}

const isMatch = (download: DownloadFile, filters: Record<string, FilterOption[]>) => {
    if (download.legacy) return false;
    if (!download.downloads_tags) return false;
    return (
        familyMatches(download, filters) && 
        hostMatches(download, filters) && 
        osMatches(download, filters)
    );
}

const familyMatches = (download: DownloadFile, filters: Record<string, FilterOption[]>) => {
    const families = filters.family;
    const productFamily = (download.product_line == '' || download.product == 'Particle Illusion Standalone') ? download.product : download.product_line;
    if (families.length == 0) return true;
    const matches = families.some((f: FilterOption) => {
        return (
            f.name == productFamily || 
            f.variants.includes(productFamily)
        )
    })
    
    return matches;
}

const hostMatches = (download: DownloadFile, filters: Record<string, FilterOption[]>) => {
    const ignoreHostProducts = [
        'RLM License Server', 'Boris FX Hub'
    ];
    const family = download.product_line == '' ? download.product : download.product_line;
    if (ignoreHostProducts.includes(family)) return true;
    const productHosts = download.host.split(',');
    if (download.host_products != null){
        const supportedProducts = download.host_products.split(',');
        for (const sp of supportedProducts) productHosts.push(sp.trim());
    }

    const hosts = filters.host;
    if (hosts.length == 0) return true;
    const matches = hosts.some((h: FilterOption) =>{ 
        const phMatch = productHosts.some((ph: string) => {
            const phTrimmed = ph.trim();
            return (
                h.name == phTrimmed || 
                h.variants.includes(phTrimmed)
            )
        })
        if (phMatch){
            return true;
        }
    });

    return matches;
}

const osMatches = (download: DownloadFile, filters: Record<string, FilterOption[]>) => {
    const selected = filters.os;
    if (selected.length == 0) return true;
    // platform may list several targets, e.g. "Windows 64-bit, Windows Arm64"
    const platforms = (download.platform ?? '').split(',').map((p: string) => p.trim());
    const matches = selected.some((o: FilterOption) => {
        return platforms.some((p: string) => (
            p.toLowerCase().includes(o.key) ||
            o.name == p ||
            o.variants.includes(p)
        ));
    })

    return matches;
}
